export const _functionHelper = {
  allowNextFromTop,
  allowNextFromBlock,
  isQueType,
  checkBlockListRequired,
  summaryResult,
};

function allowNextFromBlock(_questionlist, requiredMsg, selectMsg) {
  let _isrequiredEmpty = false;
  _questionlist.forEach((item) => {
    if (item.isMandatory) {
      if (item.error) {
        _isrequiredEmpty = true;
      } else if (isQueType(item.answerType)) {
        if (item.value["first"] === "") {
          _isrequiredEmpty = true;
          item.error = true;
          item.errorMessage["first"] = requiredMsg;
        }
      } else if (!item.error && (item.value === "" || item.value == null)) {
        _isrequiredEmpty = true;
        item.error = true;
        item.errorMessage = requiredMsg;
      }
    }
  });
  return _isrequiredEmpty;
}

function allowNextFromTop(_questionlist) {
  for (const block of _questionlist) {
    for (const item of block.pruefFragenItemModels) {
      if (item.isMandatory) {
        if (isQueType(item.answerType)) {
          if (item["value"]["first"] === "") {
            return true;
          }
        } else if (item.value === "") {
          return true;
        }
      }
    }
  }
  return false;
}
function checkQuestionRequired(_questionList) {
  return _questionList.some(
    (question) =>
      question.isMandatory &&
      (isQueType(question["answerType"])
        ? question["value"]["first"] === ""
        : question.value === ""),
  );
}

function checkBlockListRequired(_blockList, isAll) {
  let isRequiredFound = false;
  let _temp;
  if (isAll === "allBlock") {
    _blockList.some((block, index) => {
      const _isRequired = checkQuestionRequired(block["pruefFragenItemModels"]);
      if (_isRequired) {
        isRequiredFound = true;
        _temp = {
          isBlockMandtory: false,
          isquestionMandtory: true,
          index: index + 1,
        };
        return true;
      }
      return false;
    });
  } else {
    const _isRequired = checkQuestionRequired(
      _blockList["pruefFragenItemModels"],
    );

    if (_isRequired) {
      isRequiredFound = true;
      _temp = {
        isBlockMandtory: false,
        isquestionMandtory: true,
        index: isAll + 1,
      };
    }
  }
  if (!isRequiredFound) {
    _temp = { isBlockMandtory: false, isquestionMandtory: false };
    return _temp;
  }
  return _temp;
}

function isQueType(_type) {
  const questionType = [
    "text",
    "objective",
    "description",
    "number",
    "rangevalue",
    "radiooption",
  ];
  return questionType.includes(_type.toLowerCase());
}

function summaryResult(data) {
  const result = {};
  let totalMandatoryQuestions = 0;
  let totalNonMandatoryQuestions = 0;
  let totalEmptyMandatoryQuestions = 0;
  let totalEmptyNonMandatoryQuestions = 0;
  let criticalIssueMandtory = 0;
  let noCriticalIssue = 0;
  let criticalIssueNonMandtory = 0;
  let mandtory = {};
  let nonMandtory = {};

  data.forEach((chapter) => {
    let hasValidBlock = false;
    let chapterMandtoryIssue = null;
    let chapterNonMandtoryIssue = null;

    chapter.checklistBlockModels.forEach((block) => {
      let mandatoryIssue = [];
      let nonMandatoryIssue = [];
      let _tempQuestion = [];
      block.pruefFragenItemModels.forEach((question) => {
        if (question.isMandatory) {
          totalMandatoryQuestions++;
          if (question.shouldTakeEquipmentOutOfOrder) {
            noCriticalIssue++;
          }
          if (isQueType(question.answerType)) {
            if (question.value["first"] === "") {
              totalEmptyMandatoryQuestions++;
            }

            if (question.shouldTakeEquipmentOutOfOrder) {
              if (question.answerType.toLowerCase() == "rangevalue") {
                if (
                  parseFloat(question.value["first"].toLowerCase().trim()) <
                    parseFloat(question.rangeValue["min"]) ||
                  parseFloat(question.value["first"].toLowerCase().trim()) >
                    parseFloat(question.rangeValue["max"])
                ) {
                  criticalIssueMandtory++;
                  mandatoryIssue.push(question);
                }
              } else if (
                question.value["first"].toLowerCase().trim() !==
                question["antwort"].toLowerCase().trim()
              ) {
                criticalIssueMandtory++;
                mandatoryIssue.push(question);
              }
            }

            // if (
            //   question.shouldTakeEquipmentOutOfOrder &&
            //   question.value["first"].toLowerCase().trim() !==
            //     question["antwort"].toLowerCase().trim()
            // ) {
            //   criticalIssueMandtory++;
            //   mandatoryIssue.push(question);
            // }
          } else {
            if (question.value === "") {
              totalEmptyMandatoryQuestions++;
            }
            if (
              question.shouldTakeEquipmentOutOfOrder &&
              question.value?.toLowerCase() !==
                question["antwort"].toLowerCase()
            ) {
              criticalIssueMandtory++;
              mandatoryIssue.push(question);
            }
          }
        } else {
          totalNonMandatoryQuestions++;
          if (question.shouldTakeEquipmentOutOfOrder) {
            noCriticalIssue++;
          }
          if (isQueType(question.answerType)) {
            if (question.value["first"] === "") {
              totalEmptyNonMandatoryQuestions++;
            }

            if (question.shouldTakeEquipmentOutOfOrder) {
              if (question.answerType.toLowerCase() == "rangevalue") {
                if (
                  parseFloat(question.value["first"].toLowerCase().trim()) <
                    parseFloat(question.rangeValue["min"]) ||
                  parseFloat(question.value["first"].toLowerCase().trim()) >
                    parseFloat(question.rangeValue["max"])
                ) {
                  criticalIssueNonMandtory++;
                  nonMandatoryIssue.push(question);
                }
              } else if (
                question.value["first"].trim().toLowerCase() !==
                question["antwort"].trim().toLowerCase()
              ) {
                criticalIssueNonMandtory++;
                nonMandatoryIssue.push(question);
              }
            }

            // if (
            //   question.shouldTakeEquipmentOutOfOrder &&
            //   question.value["first"].trim().toLowerCase() !==
            //     question["antwort"].trim().toLowerCase()
            // ) {
            //   criticalIssueNonMandtory++;
            //   nonMandatoryIssue.push(question);
            // }
          } else {
            if (question.value === "") {
              totalEmptyNonMandatoryQuestions++;
            }
            if (
              question.shouldTakeEquipmentOutOfOrder &&
              question.value.toLowerCase() !== question["antwort"].toLowerCase()
            ) {
              criticalIssueNonMandtory++;
              nonMandatoryIssue.push(question);
            }
          }
        }
      });

      if (mandatoryIssue.length > 0) {
        hasValidBlock = true;
        console.log(chapterMandtoryIssue);
        if (chapterMandtoryIssue) {
          chapterMandtoryIssue = {
            ...chapterMandtoryIssue,
            [block.id]: {
              title: block.title,
              pruefFragenItemModels: mandatoryIssue,
            },
          };
        } else {
          chapterMandtoryIssue = {
            [block.id]: {
              title: block.title,
              pruefFragenItemModels: mandatoryIssue,
            },
          };
        }
      }

      if (nonMandatoryIssue.length > 0) {
        hasValidBlock = true;
        console.log(chapterNonMandtoryIssue);
        if (chapterNonMandtoryIssue) {
          chapterNonMandtoryIssue = {
            ...chapterNonMandtoryIssue,
            [block.id]: {
              title: block.title,
              pruefFragenItemModels: nonMandatoryIssue,
            },
          };
        } else {
          chapterNonMandtoryIssue = {
            [block.id]: {
              title: block.title,
              pruefFragenItemModels: nonMandatoryIssue,
            },
          };
        }
      }
    });

    if (chapterMandtoryIssue) {
      if (mandtory) {
        mandtory = {
          ...mandtory,
          [chapter.id]: {
            title: chapter.title,
            blockList: chapterMandtoryIssue,
          },
        };
      } else {
        mandtory = {
          [chapter.id]: {
            title: chapter.title,
            blockList: chapterMandtoryIssue,
          },
        };
      }
    }
    if (chapterNonMandtoryIssue) {
      if (nonMandtory) {
        nonMandtory = {
          ...nonMandtory,
          [chapter.id]: {
            title: chapter.title,
            blockList: chapterNonMandtoryIssue,
          },
        };
      } else {
        nonMandtory = {
          [chapter.id]: {
            title: chapter.title,
            blockList: chapterNonMandtoryIssue,
          },
        };
      }
    }
  });
  result.counts = {
    totalMandatoryQuestions: totalMandatoryQuestions,
    totalNonMandatoryQuestions: totalNonMandatoryQuestions,
    totalEmptyMandatoryQuestions: totalEmptyMandatoryQuestions,
    totalEmptyMandatoryQuestions: totalEmptyMandatoryQuestions,
    totalEmptyNonMandatoryQuestions: totalEmptyNonMandatoryQuestions,
    criticalIssueNonMandtory: criticalIssueNonMandtory,
    criticalIssueMandtory: criticalIssueMandtory,
    noCriticalIssue: noCriticalIssue,
  };
  result.mandatory = mandtory;
  result.nonMandatory = nonMandtory;

  return result;
}
